import Link from 'next/link';
import Container from '@/ui/container';
import Header from '@/features/layout/header';
import Footer from '@/features/layout/footer';
import AdminAccess from './admin-access';

export default function Layout({ children, session }) {
	const currentYear = new Date().getFullYear();
	return (
		<div className=" text-gray-700 min-h-screen flex flex-col relative">
			<Header>
				<Container>
					<div className="flex h-16 items-center justify-between">
						<div className="text-white text-3xl font-semibold">
							<Link href="/">ELF FUND</Link>
						</div>
						<div className="flex space-x-4">
							<Link href="/help" passHref>
								<button className="p-2 sm:px-6 sm:py-1.5 text-xs sm:text-sm bg-white sm:mr-3 rounded-md hover:bg-gray-200 text-gray-700">
									Contact us
								</button>
							</Link>
							{session && (
								<div>
									<button
										className="p-2 sm:px-6 sm:py-1.5 text-xs sm:text-sm bg-white mr-3 rounded-md hover:bg-gray-200 text-gray-700"
										onClick={async () =>
											await window.Clerk.signOut()
										}
									>
										Logout
									</button>
								</div>
							)}
						</div>
					</div>
				</Container>
				{/* <MobileNav />
				<DesktopNav /> */}
			</Header>
			<div className="grow">{children}</div>
			<Footer>
				<div className=" min-h-10 bg-gray-800 pt-4 pb-4">
					<Container>
						<div className="flex justify-around items-center text-white">
							<div>©{currentYear} Elf Fund</div>

							<AdminAccess session={session} />
						</div>
					</Container>
				</div>
			</Footer>
		</div>
	);
}
